import makeService from './api';

export default makeService('quality_check_values');
